export const COMPANIES_FETCH = 'COMPANIES_FETCH';
export const COMPANIES_IS_FETCING = 'COMPANIES_IS_FETCHING';
export const COMPANIES_API = 'companies';
export const COMPANY_EDIT = 'COMPANY_EDIT';
export const COMPANY_SAVE = 'COMPANY_SAVE';
export const COMPANY_FILTER = 'COMPANY_FILTER';


// WEBPACK FOOTER //
// ./src/constants/companies.js